import request from '../../utils/request';

export const apiService = {
    search: (data) => {
        return request({
            url: '/law-file/query',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    deleteById: (data) => {
        return request({
            url: '/law-file/deleteByIds',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    queryAgent: () => {
        return request({
            url: '/law-file/queryAgent',
            method: 'get',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            }
        })
    },
    save: (data) => {
        return request({
            url: '/law-file/save',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    submit: (data) => {
        return request({
            url: '/law-file/submit',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    complete: (data) => {
        return request({
            url: '/law-file/complete',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    queryLawFileInfo: (id) => {
        return request({
            url: '/law-file/queryLawFileInfo/' + id,
            method: 'get',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
        })
    },
    //签字附件 上传后调用归档接口
    pigeonhole: (id) => {
        return request({
            url: '/law-file/pigeonhole/' + id + '/Y',
            method: 'get',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
        })
    },
    queryPrimaryKey: (id) => {
        return request({
            url: '/law-file/queryPrimaryKey',
            method: 'get',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
        })
    },
}